import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NoticiaPage } from 'src/app/pages/noticia/noticia.page';
import { NoticiaDetalhesPage } from '../noticia-detalhes/noticia-detalhes.page';
import { CommonModule } from '@angular/common';
import { ImagePipe } from 'src/app/pipes/image/image';
import { register } from 'swiper/element/bundle';
import { TranslateModule } from '@ngx-translate/core';
register();
@Component({
  selector: 'slider-noticia',
  templateUrl: 'slider-noticia.html',
  styleUrls: ['./slider-noticia.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ImagePipe,
    TranslateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})

export class SliderNoticiaComponent implements OnInit, AfterViewInit {
  @ViewChild('swiperElement', { static: false }) swiperElementRef!: any;
  @Input()
  config: any = {};
  noticiaList: any = [];
  maximoNoticia: any = {
    maximo: false,
    maximoQtd: 0
  };

  constructor(public modalCtrl: ModalController) { }

  ngAfterViewInit(): void {
    const swiperEl = this.swiperElementRef?.nativeElement;
    if (swiperEl) {
      swiperEl.initialize?.();
    }
  }

  ngOnInit() {
    if (this.config.idNoticiaCategoria == -1) {
      this.noticiaList = this.config.categoria.noticias;
    } else {
      if (this.config.categoria.noticias.length > 6) {
        this.maximoNoticia.maximo = true;
        this.maximoNoticia.maximoQtd = this.config.categoria.noticias.length - 6;
      }
      this.noticiaList = this.config.categoria.noticias.slice(0, 5);
    }

    setTimeout(() => {
      const swiperEl = this.swiperElementRef?.nativeElement;
      swiperEl?.initialize?.();  
    }, 90);
  }

  getFontColor() {
    return this.config.font_color;
  }

  async abrirNoticia(noticia: { id: string; }) {
    let modalPage = await this.modalCtrl.create({ component: NoticiaDetalhesPage, componentProps: { 'id': noticia.id } });
    modalPage.present();
  }

  async abrirCategoria() {
    let modalPage = await this.modalCtrl.create({ component: NoticiaPage, componentProps: { categorias: this.config.categoria.id, titulo: this.config.categoria.categoria } });
    modalPage.present();
  }
}
